/* 🤖 this file was generated by svg-to-ts */
export const matIconBookmarkRemove: {
  name: 'bookmark-remove';
  data: string;
} = {
  name: 'bookmark-remove',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 11v6.97l-5-2.14-5 2.14V5h6V3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V11h-2zm4-4h-6V5h6v2z"/></svg>`
};
